import React from 'react';
// import { Link } from 'react-router-dom'; // (optional) remove if not used
import './style-sheet.css';




export const Prices = () => {
  return (
    
    <main className="div-center grid">
      <section className="div-center">
        <div className="omTitle"> 
        <h2 className="h2-blue">Prisliste</h2>
        </div>

        <div className="table-wrapper">
          <table className="table-price">
            <thead>
              <tr>
                <th>Pakke</th>
                <th>Inkluderer</th>
                <th>Priser</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td data-label="Pakke">Basis Pakke</td>
                <td data-label="Inkluderer">
                  Op til 3 sider, skabelonbaseret design, kontaktformular,
                  responsivt layout, basal SEO
                </td>
                <td data-label="Priser">4.000 kr. – 5.500 kr.</td>
              </tr>
              <tr>
                <td data-label="Pakke">Standard Pakke</td>
                <td data-label="Inkluderer">
                  Op til 7 sider, brugerdefinerede designelementer,
                  CMS-integration, avancerede kontaktformularer, responsivt
                  layout, standard SEO-optimering
                </td>
                <td data-label="Priser">7.500 kr. – 10.000 kr.</td>
              </tr>
              <tr>
                <td data-label="Pakke">Premium Pakke</td>
                <td data-label="Inkluderer">
                  Op til 10 sider, fuldt tilpasset design, avanceret CMS,
                  webshop-funktion (valgfri), blog, avanceret SEO, opsætning af
                  statistiksporing
                </td>
                <td data-label="Priser">15.000 kr. – 25.000 kr.</td>
              </tr>
              <tr>
                <td data-label="Pakke">E-handels Pakke</td>
                <td data-label="Inkluderer">
                  Tilpasset design, opsætning af produktkatalog, integration af
                  indkøbskurv, betalingsløsning, lagerstyring, basal træning i
                  butiksstyring, standard SEO for produktsider
                </td>
                <td data-label="Priser">25.000 kr. – 45.000 kr.</td>
              </tr>
              <tr>
                <td data-label="Pakke">Ekstra Services</td>
                <td data-label="Inkluderer">
                  Indholdsproduktion (500 – 1.000 kr. pr. side),<br />
                  Løbende vedligeholdelse (500 – 2.000 kr. pr. måned),<br />
                  Avanceret SEO (2.000 – 5.000 kr.),<br />
                  Integration med sociale medier (1.000 – 2.000 kr.),<br />
                  Logo & branding design (1.500 – 4.000 kr.)
                </td>
                <td data-label="Priser">Varierende</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="3">
                  *Priserne er kun til Demo og da jeg endnu ikke tilbyder nogle
                  ydelser.
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </section>
    </main>
  );
};
